import {
    Alert,
    Box,
    Button,
    Card,
    CardContent,
    CircularProgress,
    Grid,
    TextField,
    Typography
} from "@mui/material";
import Logger from "../../../services/Logger";
import React, { useState } from "react";
import TestEmailService from "../../../services/TestEmailService";
import Item from "../../components/Item";

export default function EmailMain() {
    const [emailData, setEmailData] = useState({
        from: "NoReply@puzzleinteract.com",
        to: "syc0701@gmail.com",
        subject: "test 1",
        content: "this is test content"
    });
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    const handleInputChange = (field) => (event) => {
        setEmailData(prev => ({
            ...prev,
            [field]: event.target.value
        }));
    };

    const handleSendEmail = async () => {
        setLoading(true);
        setMessage("");
        setError("");

        try {
            const response = await TestEmailService.sendEmail(emailData);
            if (response.code === "FAILURE") {
                setError(response.message);
            } else {
                setMessage("Email sent successfully!");
                Logger.log("Email response:", response);
            }
        } catch (error) {
            setError("Failed to send email: " + (error.message || "Unknown error"));
            Logger.error("Email error:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2} sx={{ justifyContent: "center" }}>
                <Grid size={{ xs: 12 }}>
                    <Item>
                        <Card>
                            <CardContent>
                                <Typography variant="h5" component="h2" gutterBottom>
                                    Send Test Email
                                </Typography>

                                {message && (
                                    <Alert severity="success" sx={{ mb: 2 }}>
                                        {message}
                                    </Alert>
                                )}

                                {error && (
                                    <Alert severity="error" sx={{ mb: 2 }}>
                                        {error}
                                    </Alert>
                                )}

                                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                                    <TextField
                                        label="From"
                                        value={emailData.from}
                                        onChange={handleInputChange("from")}
                                        fullWidth
                                        variant="outlined"
                                    />

                                    <TextField
                                        label="To"
                                        value={emailData.to}
                                        onChange={handleInputChange("to")}
                                        fullWidth
                                        variant="outlined"
                                    />

                                    <TextField
                                        label="Subject"
                                        value={emailData.subject}
                                        onChange={handleInputChange("subject")}
                                        fullWidth
                                        variant="outlined"
                                    />

                                    <TextField
                                        label="Content"
                                        value={emailData.content}
                                        onChange={handleInputChange("content")}
                                        fullWidth
                                        multiline
                                        rows={4}
                                        variant="outlined"
                                    />

                                    <Button
                                        variant="contained"
                                        onClick={handleSendEmail}
                                        disabled={loading}
                                        sx={{ alignSelf: "flex-start" }}
                                    >
                                        {loading ? (
                                            <>
                                                <CircularProgress size={20} sx={{ mr: 1 }} />
                                                Sending...
                                            </>
                                        ) : (
                                            "Send Email"
                                        )}
                                    </Button>
                                </Box>
                            </CardContent>
                        </Card>
                    </Item>
                </Grid>
            </Grid>
        </Box>
    );
}
